module.exports = __webpack_public_path__ + "img/brand-fill.a88e87ab.svg";